"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _loadingNModule = _interopRequireDefault(require("./loading-n.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingN = function LoadingN(_ref) {
  var className = _ref.className,
      size = _ref.size;
  return _react["default"].createElement("div", {
    className: className,
    style: {
      height: "".concat(size, "px"),
      width: "".concat(size, "px")
    }
  }, _react["default"].createElement("span", {
    className: (0, _classes["default"])('screen-reader-only')
  }, "Loading..."), _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-316 118.2 325.8 325.8",
    "aria-hidden": "true"
  }, _react["default"].createElement("path", {
    fill: "none",
    d: "M-207.4,335.4L-207.4,335.4L-207.4,335.4L-207.4,335.4 M-207.4,335.4L-207.4,335.4L-207.4,335.4L-207.4,335.4"
  }), _react["default"].createElement("path", {
    className: _loadingNModule["default"]['top-left'],
    fill: "#00ae4d",
    d: "M-208.1,118.9c-1.1-0.4-2.3-0.6-3.5-0.6h-97.3c-3.9,0-7.1,3.2-7.1,7.2v101.4L-208.1,118.9z"
  }), _react["default"].createElement("path", {
    fill: "none",
    d: "M-207.4,335.4L-207.4,335.4L-207.4,335.4L-207.4,335.4"
  }), _react["default"].createElement("path", {
    className: _loadingNModule["default"]['bottom-left'],
    fill: "#00ae4d",
    d: "M-313.9,441.9c1.3,1.3,3.2,2.1,5.1,2.1h94.3c3.9,0,7.1-3.2,7.1-7.1V335.4L-313.9,441.9z"
  }), _react["default"].createElement("path", {
    className: _loadingNModule["default"]['middle-right'],
    fill: "#00682c",
    d: "M-98.8,226.8v216.3l0.6,0.3l107.9-108L-98.8,226.8z"
  }), _react["default"].createElement("path", {
    fill: "none",
    d: "M-207.4,335.4L-207.4,335.4L-207.4,335.4"
  }), _react["default"].createElement("path", {
    className: _loadingNModule["default"]['left-pillar'],
    fill: "#8ccb32",
    d: "M-207.4,335.4V119.1c-0.2-0.1-0.4-0.2-0.6-0.3l-107.9,108v210c0,1.9,0.8,3.7,2.1,5L-207.4,335.4z"
  }), _react["default"].createElement("path", {
    className: _loadingNModule["default"]['right-pillar'],
    fill: "#8ccb32",
    d: "M9.8,335.4v-210c0-3.9-3.2-7.2-7.1-7.2c0,0,0,0,0,0h-94.3c-3.9,0-7.1,3.2-7.1,7.1v101.4L9.8,335.4z M9.8,335.4 L-98.2,443.4c1.1,0.4,2.3,0.6,3.5,0.6H2.6c3.9,0,7.1-3.2,7.1-7.1L9.8,335.4L9.8,335.4z"
  }), _react["default"].createElement("path", {
    fill: "#d0d1d3",
    d: "M-207.4,335.4L-207.4,335.4L-207.4,335.4"
  }), _react["default"].createElement("path", {
    className: _loadingNModule["default"]['middle-pillar'],
    fill: "#00ae4d",
    d: "M-204.5,121.2c-0.9-0.8-1.8-1.5-2.9-2v216.2l105.7,105.6c0.9,0.8,1.8,1.5,2.9,2V226.8L-204.5,121.2z"
  })));
};

LoadingN.propTypes = {
  className: _propTypes["default"].string,
  size: _propTypes["default"].number
};
LoadingN.defaultProps = {
  size: 100,
  className: null
};
var _default = LoadingN;
exports["default"] = _default;